import React, {Component} from "react";

import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import {Form, Icon, Input, Row, Col, Card, Select} from "antd";
const FormItem = Form.Item;
const Option = Select.Option;

const {TextArea} = Input;


const styles = theme => ({
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
});

class SignUp extends Component {

    constructor(props) {
        super();
        this.signUpData = {};
        this._onChange = this._onChange.bind(this);
        this._signUp = this._signUp.bind(this);
    }

    componentWillMount() {
        if ("isRegister" in localStorage || this.props.signup.isRegister) {
            this.props.history.push("/");
        }
    }

    componentDidUpdate() {
        if ("isRegister" in localStorage || this.props.signup.isRegister) {
            this.props.history.push("/");
        }
    }


    _onChange(e) {
        if (e.target.name === "phone")
        {
            let conCode = "+94";
            this.signUpData[e.target.name] = conCode+e.target.value;
        }else {
            this.signUpData[e.target.name] = e.target.value;
        }

    }

    _signUp(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                //this.props.signup.iconLoading = true;
                this.props.userRegister(this.signUpData);
                this.props.form.resetFields();
                //this.signUpData = [];
            }
        });
    }

    render() {
    //console.debug("SignUp",this.props);
    //console.debug("siData",this.signUpData);
        const {getFieldDecorator} = this.props.form;
        const prefixSelector = getFieldDecorator("prefix", {
            initialValue: "94",
        })(
            <Select id='conCode' style={{width: 70}}>
                <Option value="94">+94</Option>
            </Select>
        );
        const { classes, signup } = this.props;

        return (
            <div style={{marginTop: "20x"}}>
                <Row>
                    <Col lg={{span: 8, offset: 8}}>
                        <Card style={{boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}>
                            <h2 style={{textAlign: "center"}}>Sign Up</h2>
                            <Form className="signUp-form" onSubmit={this._signUp}>
                                <FormItem>
                                    {getFieldDecorator("name", {
                                        rules: [{required: true, message: "Please input your Name!"}],
                                    })(
                                        <Input name="name"
                                            prefix={<Icon type="user" style={{color: "rgba(0,0,0,.25)"}}/>}
                                            onChange={this._onChange} placeholder="Name"/>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator("email", {
                                        rules: [
                                            {required: true, message: "Please input your Email!"},
                                            {type: "email", message: "Invalid Email."}
                                        ],
                                    })(
                                        <Input name="email"
                                            prefix={<Icon type="mail" style={{color: "rgba(0,0,0,.25)"}}/>}
                                            onChange={this._onChange} type="email" placeholder="Email"/>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator("phone", {
                                        rules: [
                                            {required: true, min: 9, max:9, message: "Invalid Mobile!"}
                                        ],
                                    })(
                                        <Input name="phone" onChange={this._onChange} placeholder="Phone"
                                            prefix={<Icon type="phone" style={{color: "rgba(0,0,0,.25)"}}/>}
                                            addonBefore={prefixSelector} style={{width: "100%"}}/>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator("companyname", {
                                        rules: [{required: true, message: "Please input your CompanyName!"}],
                                    })(
                                        <Input name="companyname"
                                            prefix={<Icon type="bank" style={{color: "rgba(0,0,0,.25)"}}/>}
                                            onChange={this._onChange} placeholder="CompanyName"/>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator("purpose", {
                                        rules: [{required: true, message: "Please input your Purpose!"}],
                                    })(
                                        <TextArea name="purpose"
                                            prefix={<Icon type="bank" style={{color: "rgba(0,0,0,.25)"}}/>}
                                            onChange={this._onChange} placeholder="Purpose"
                                            autosize={{minRows: 2, maxRows: 6}}/>
                                    )}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator("password", {
                                        rules: [
                                            {required: true, message: "Please input your Password!"},
                                            {required: true, min: 6, message: "Password must contain at least 6 characters"}
                                            // {
                                            //   pattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$',
                                            //   message: 'Password must contain at least eight characters, at least one number and both lower and uppercase letters and special characters'
                                            // }
                                        ],
                                    })(
                                        <Input name="password"
                                            prefix={<Icon type="lock" style={{color: "rgba(0,0,0,.25)"}}/>}
                                            onChange={this._onChange} type="password" placeholder="Password"/>
                                    )}
                                </FormItem>


                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    disabled={signup.loading ? true : false}
                                >
                    Sign up
                                </Button>

                                {/* <Button type="primary" loading={this.props.signup.iconLoading} icon="solution" htmlType="submit"
                                            className="login-form-button">
                                        SignUp
                                    </Button> */}

                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

const signUpForm = Form.create()(SignUp);

export default withStyles(styles)(signUpForm);